import { ref, reactive, computed, onMounted } from 'vue'
import { defineStore } from 'pinia'

import Settings from '@model/settings'

export const useNotification = defineStore('notification', () => {

    const notifications = ref([])

    const getNotifications = computed(() => {
        return notifications.value
    })

    const isNotificationsLoading = ref(false)

    // Fetch notifications
    const fetchNotifications = async () => {
        isNotificationsLoading.value = true
        const response = await Settings.init().get('notification')
        Log('notification', response)
        isNotificationsLoading.value = false
        notifications.value = response
        return response
    }

    // update notification
    const updateNotification = async () => {
        const response = await Settings.init().update({
            notification: notifications.value
        })
        Log(response)
        Toast.success('Notification updated successfully')
        return response
    }

    onMounted( () => {
        fetchNotifications()
    })

    // delete notification
    const deleteNotification = async (notification_id) => {
        console.log('delete notification', notification_id)
        // const response = await Ajax.post('admin_delete_notification', { notification_id })

        // if (response.success) {
        //     notifications.value = notifications.value.filter(notification => notification.id !== notification_id)
        // }

        // Log('notification DELETE', response, notification_id)

        // return response
    }


    // export
    return {
        notifications,
        getNotifications,
        isNotificationsLoading,


        fetchNotifications,
        deleteNotification,
        updateNotification,

    }
})
